import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';

class LabelHeaderRenderer extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { 
      currentPage, totalPage, onSelectPage, cellType,
      isPrevious, isNext,
    } = this.props;
    if (totalPage <= 1) {
      return null;
    }
    const hasPrev = currentPage > 1;
    const hasNext = currentPage < totalPage;
    return (
      <ButtonGroup bsSize="xs">
        {isPrevious && 
          <Button 
            bsStyle="default" 
            bsSize="xs"
            disabled={!hasPrev}
            onClick={() => {
              onSelectPage(cellType, -1);
            }}
          >
            <Fa name="chevron-up" />
          </Button>
        }
        {isNext && 
          <Button 
            bsStyle="default" 
            bsSize="xs"
            disabled={!hasNext}
            onClick={() => {
              onSelectPage(cellType, 1);
            }}
          >
            <Fa name="chevron-down" />
          </Button>
        }
      </ButtonGroup>
    );
  }
}

LabelHeaderRenderer.propTypes = {
  isPrevious: PropTypes.bool,
  isNext: PropTypes.bool,
  onSelect: PropTypes.func,
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
  cellType: PropTypes.string.isRequired,
  onSelectPage: PropTypes.func,
};
LabelHeaderRenderer.defaultProps = {
  isPrevious: true,
  isNext: true,
  opportunityIds: null,
  totalPage: 0,
  currentPage: 1,
  onSelectPage: () => {},
};

export default LabelHeaderRenderer;
